import { useReducer } from "react";

import CartContext from "./cart-context";

const defaultCartState = {
  items: [],
  ingredients: {},
};

const cartReducer = (state, action) => {
  // add cocktail to cart
  if (action.type === "ADD") {
    //check if cocktail is already in cart
    const existingCartItemIndex = state.items.findIndex(
      (item) => item._id === action.item._id
    );

    const existingCartItem = state.items[existingCartItemIndex];

    let updatedItems;
    let updatedItem;

    //if cocktail is already in cart, increment the count and add ingredient amounts
    // if not, add cocktail to items (cart cocktails)

    if (existingCartItem) {
      updatedItem = {
        ...existingCartItem,
        amount: existingCartItem.amount + 1,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    } else {
      updatedItem = {
        ...action.item,
        amount: 1,
      };
      updatedItems = state.items.concat(updatedItem);
    }

    /* Updating cart ingredients list by iterating through every ingredients in the drink added to
     the cart and either adding new ingredient or increasing volume of existing ingredient */
    let updatedIngredients = { ...state.ingredients };

    action.item.ingredients.forEach((ing) => {
      if (state.ingredients && ing.ingredient.title in state.ingredients) {
        const updatedIngredient = {
          ...updatedIngredients[ing.ingredient.title],
          volume: updatedIngredients[ing.ingredient.title].volume + ing.volume,
        };

        updatedIngredients[ing.ingredient.title] = updatedIngredient;
      } else {
        updatedIngredients[ing.ingredient.title] = {
          ...ing.ingredient,
          volume: ing.volume,
        };
      }
    });

    return {
      items: updatedItems,
      ingredients: updatedIngredients,
    };
  }

  //Decrement cocktail by one in cart
  if (action.type === "REMOVE") {
    // Check if cocktail is in Cart
    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.id
    );

    // If cocktail is not in cart, return
    if (existingCartItemIndex === -1) {
      return { items: state.items };
    }

    // If cocktail is in cart, remove object
    const existingCartItem = state.items[existingCartItemIndex];

    let updatedItems;
    let updatedItem;

    // If there is only one left of given cocktail, remove it completely from cart
    if (existingCartItem.amount === 1) {
      updatedItems = state.items.filter((item) => item.id !== action.id);
    } else {
      updatedItem = {
        ...existingCartItem,
        amount: existingCartItem.amount - 1,
      };
      updatedItems = [...state.items];
      updatedItems[existingCartItemIndex] = updatedItem;
    }

    /* Updating cart ingredients list by iterating through every ingredients in the drink removed from
     the cart and either decreasing the amount or removing ingredient */
    let updatedIngredients = { ...state.ingredients };

    /* go through the ingredients in the existingCartItem object (cocktail object) and remove the appropriate 
    volume of each cocktail ingredient from the cart */
    existingCartItem.ingredients.forEach((ing) => {
      // remove ingredient from cabinet if volume is 0
      if (updatedIngredients[ing.ingredient.title].volume === ing.volume) {
        delete updatedIngredients[ing.ingredient.title];
      } else {
        const updatedIngredient = {
          ...updatedIngredients[ing.ingredient.title],
          volume: updatedIngredients[ing.ingredient.title].volume - ing.volume,
        };

        updatedIngredients[ing.ingredient.title] = updatedIngredient;
      }
    });

    return {
      items: updatedItems,
      ingredients: updatedIngredients,
    };
  }

  // Remove all of same cocktail from cart
  if (action.type === "CLEAR_ITEM") {

    const existingCartItemIndex = state.items.findIndex(
      (item) => item.id === action.id
    );

    if (existingCartItemIndex === -1) {
      return { items: state.items };
    }

    let updatedItems = [...state.items];

    updatedItems.splice(existingCartItemIndex, 1);

    const existingCartItem = state.items[existingCartItemIndex];

    /* Updating cart ingredients list by iterating through every ingredients in the drink removed from
     the cart and either decreasing the amount or removing ingredient */
    let updatedIngredients = { ...state.ingredients };

    /* go through the ingredients in the existingCartItem object (cocktail object) and remove the appropriate 
    volume of each cocktail ingredient from the cart */
    existingCartItem.ingredients.forEach((ing) => {

      // remove ingredient from cabinet if volume is 0
      if (
        updatedIngredients[ing.ingredient.title].volume ===
        ing.volume * existingCartItem.amount
      ) {
        delete updatedIngredients[ing.ingredient.title];
      } else {
        const updatedIngredient = {
          ...updatedIngredients[ing.ingredient.title],
          volume:
            updatedIngredients[ing.ingredient.title].volume -
            ing.volume * existingCartItem.amount,
        };

        updatedIngredients[ing.ingredient.title] = updatedIngredient;
      }
    });

    return {
      items: updatedItems,
      ingredients: updatedIngredients,
    };
  }

  if (action.type === "SAVE") {
    // localStorage.setItem("cartItems", JSON.stringify(state.items));
    // localStorage.setItem("cartIngredients", JSON.stringify(state.ingredients));
    return {
      items: state.items,
      ingredients: state.ingredients,
    };
  }

  if (action.type === "CLEAR") {
    return {
      items: [],
      ingredients: [],
    };
  }
};

const CartProvider = (props) => {
  // let savedCartItems = null;
  // let savedCartIngredients = null;
  let savedCartItems = [];
  let savedCartIngredients = [];

  // try {
  //   savedCartItems = JSON.parse(localStorage.getItem("cartItems"));
  // } catch (error) {
  //   console.error("Failed to parse cart items from localStorage:", error);
  //   savedCartItems = []; // or any default value you want to set
  // }

  // try {
  //   savedCartIngredients = JSON.parse(localStorage.getItem("cartIngredients"));
  // } catch (error) {
  //   console.error("Failed to parse cart ingredients from localStorage:", error);
  //   savedCartIngredients = []; // or any default value you want to set
  // }
  // console.log("one");


  defaultCartState.items = [];
  defaultCartState.ingredients = [];

  // console.log("EXECUTING 1")

  // if there are items saved into browser local storage, save them to cart context
  if (savedCartItems) {
    defaultCartState.items = savedCartItems;
  }

  //if there are ingredients saved into browser local storage, save them to cart context
  if (savedCartIngredients) {
    defaultCartState.ingredients = savedCartIngredients;
  }


  const [cartState, dispatchCartAction] = useReducer(
    cartReducer,
    defaultCartState
  );

  const addItemToCartHandler = (item) => {
    dispatchCartAction({ type: "ADD", item: item });
  };

  const removeItemFromCartHandler = (id) => {
    dispatchCartAction({ type: "REMOVE", id: id });
  };

  const clearItemFromCartHandler = (id) => {
    dispatchCartAction({ type: "CLEAR_ITEM", id: id });
  };

  const findIngredientHandler = (id) => {
    dispatchCartAction({ type: "FIND_INGREDIENT", id: id });
  };

  const saveCartHandler = () => {
    dispatchCartAction({ type: "SAVE" });
  };

  const clearCartHandler = () => {
    dispatchCartAction({ type: "CLEAR" });
  };

  const cartContext = {
    items: cartState.items,
    ingredients: cartState.ingredients,
    addItem: addItemToCartHandler,
    removeItem: removeItemFromCartHandler,
    clearItem: clearItemFromCartHandler,
    findIngredient: findIngredientHandler,
    saveCart: saveCartHandler,
    clearCart: clearCartHandler,
  };

  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  );
};

export default CartProvider;
